export const lineHeights = {
  base: 1.5,
  shorter: 1.15,
  short: 1.36
};
